import React from "react";
import { NavLink } from "react-router-dom";
import "./SubMenu.css";
import logo from "../../../assets/images/logo.png";

const SubMenu = () => {
  return (
    <div className="card sub-menu-card">
      <div className="card-body mr-5">
        <div className="d-flex flex-column align-items-stretch flex-shrink-0 bg-body-tertiary">
          <div className="list-group list-group-flush border-bottom scrollarea">
            <NavLink
              to="orders"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>Orders</span>
            </NavLink>
            <NavLink
              to="phone"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>Phone</span>
            </NavLink>
            <NavLink
              to="meetings"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>Meetings</span>
            </NavLink>
            <NavLink
              to="diagrams"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>Diagrams</span>
            </NavLink>
            <NavLink
              to="/diagrams-full-screen"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>TV Screen</span>
            </NavLink>
            <NavLink
              to="reports"
              className="list-group-item list-group-item-action py-2 mb-1 lh-sm rounded menu-link"
              aria-current="true"
            >
              <span>Reports</span>
            </NavLink>
          </div>
        </div>
        <p className="position-absolute bottom-0 end-0 px-3 pb-2 logo d-flex justify-content-end w-100 align-items-end text-dark fw-bold">
          {" "}
          powered by{" "}
          <img
            src={logo}
            className="ms-1"
            width={120}
            alt="Quantum Foundry Logo"
          />
        </p>
      </div>
    </div>
  );
};

export default SubMenu;
